import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_widget_ext_RowClass} from '../../../dbschema';


export class WidgetExtensionContainerModel extends BaseContainerModel {
  bl_cms_widget_ext: bl_cms_widget_ext_RowClass = new bl_cms_widget_ext_RowClass();
}
